import React, { FC, useState } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";

import GreenCardRequestModal from "@/components/features/GreenCard/GreenCardRequestModal/GreenCardRequestModal";
import { Card } from "@/components/molecules";
import { InsuredGood, Permissions } from "@/shared/domain";
import { isABroker, useAuth, useNavigation } from "@/shared/hooks";

import { InsuredGoodRootCategory } from "../../utils/InsuredGoodRootCategory";

type InsuredGoodItemProps = {
    insuredGood: InsuredGood;
};

export const InsuredGoodItem: FC<InsuredGoodItemProps> = ({ insuredGood }) => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const { navToInsuredGoodDetail } = useNavigation();
    const [showGreenCardModal, setShowGreenCardModal] = useState(false);

    const canViewDetails = user.hasPermission(Permissions.ViewRisksDetails, insuredGood.policyholderId);

    const handleInsuredGoodItemClick = () => {
        if (insuredGood.id) {
            canViewDetails && navToInsuredGoodDetail(insuredGood);
        }
    };

    const handleDuplicateGreenCard = (e) => {
        setShowGreenCardModal(true);
        e.stopPropagation();
    };

    const infos = [];

    infos.pushIf(
        insuredGood.canRequestGreenCard && user.hasPermission(Permissions.GetGreenCard, insuredGood.policyholderId),
        <div
            className={clsx("headerActionLink", isABroker() && "disabled")}
            onClick={!isABroker() && handleDuplicateGreenCard}
            data-testid={`insured_good_item-button-greencard_${insuredGood.id}`}
            key={`insured_good_item-button-greencard_${insuredGood.id}`}
        >
            {t("Common.RequestGreenCard")}
        </div>,
    );
    return (
        <>
            {showGreenCardModal && (
                <GreenCardRequestModal insuredGood={insuredGood} onClose={() => setShowGreenCardModal(false)} />
            )}
            <Card
                onClickCard={handleInsuredGoodItemClick}
                className="goodsItem"
                clickable={canViewDetails}
                owner={insuredGood.policyHolder}
                categoryIcon={InsuredGoodRootCategory.getFromId(insuredGood.category.id).categoryIcon}
                title={insuredGood.type.name}
                text={insuredGood.name}
                dataTestId={`insured_good_item-card-${insuredGood.id}`}
                infos={infos}
            />
        </>
    );
};

export default InsuredGoodItem;
